import Vue from "vue";
import Component from "vue-class-component";
import ServiceDetail from "@/components/Home/Services/ServiceAppoint/ServiceDetail/ServiceDetail.vue";
import ServiceTimeSelect from "@/components/Home/Services/ServiceTimeSelect/ServiceTimeSelect.vue";

const ServiceAppointProps = Vue.extend({
  props: {
    serviceAppoint: Object,
  },
});

@Component({
  name: "ServiceAppoint",
  components: {
    "service-detail": ServiceDetail,
    "service-time-select": ServiceTimeSelect,
  },
})
export default class extends ServiceAppointProps {
  constructor() {
    super();
  }
}
